//export const API_BASE_URL = "http://localhost/";
export const API_BASE_URL = "https://api.servergarden.hu/";
export const SITE_TITLE = "Servergarden";
export const LANGUAGES = ["hu", "en"];

export const VUE_APP_I18N_LOCALE="hu"
export const VUE_APP_I18N_FALLBACK_LOCALE="hu"
